import { motion } from "framer-motion";

export const ProblemSolution = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-bold text-center text-primary mb-16"
        >
          Transform Your Child's Future
        </motion.h2>
        <div className="grid md:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-red-50 p-8 rounded-2xl"
          >
            <h3 className="text-2xl font-bold text-red-600 mb-4">The Challenge</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="text-red-500 mt-1">❌</span>
                <p className="text-gray-600">Lack of physical activity in daily routine</p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-red-500 mt-1">❌</span>
                <p className="text-gray-600">Decreased social interaction and confidence</p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-red-500 mt-1">❌</span>
                <p className="text-gray-600">Limited opportunities for skill development</p>
              </li>
            </ul>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-green-50 p-8 rounded-2xl"
          >
            <h3 className="text-2xl font-bold text-green-600 mb-4">Our Solution</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="text-green-500 mt-1">✓</span>
                <p className="text-gray-600">Engaging gymnastics programs tailored for all levels</p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-500 mt-1">✓</span>
                <p className="text-gray-600">Supportive community and expert guidance</p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-500 mt-1">✓</span>
                <p className="text-gray-600">Comprehensive physical and mental development</p>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};